import React from 'react';
import { useHistory } from 'react-router-dom';
import Header from '../components/Header';
import HeaderTitle from '../components/HeaderTitle';
import { NavbarToggle } from '../components/Navbar';
import { useSidebar } from '../layouts/Dashboard';
import UmrahPackagesTable from '../components/UmrahPackagesTable';
import { logout } from '../services/authService';
import './UmrahPackages.css';

const UmrahPackages = () => {
  const { toggleSidebar } = useSidebar();
  const history = useHistory();

  const handleLogout = async () => {
    try {
      await logout();
      history.push('/login');
    } catch (error) {
      console.error('Logout error:', error);
      history.push('/login');
    }
  };

  return (
    <div className="umrah-packages">
      <Header>
        <div className="packages-topbar">
          <div className="effektToggle">
            <NavbarToggle onToggle={toggleSidebar} />
            <HeaderTitle>Packages</HeaderTitle>
          </div>
          <button 
            className="logout-button" 
            onClick={handleLogout}
            type="button"
          >
            Logout
          </button>
        </div>
      </Header>

      <div className="packages-section">
        <div className="section-header">
          <h2>Umrah Packages Management</h2>
          <p className="section-subtitle">Manage and configure Umrah packages</p>
        </div>

        <div className="packages-content">
          <UmrahPackagesTable />
        </div>
      </div>
    </div>
  );
};

export default UmrahPackages;

